<template>
    <div
        class="ds-accordion-item transition-border group duration-150"
        :class="{
            'radius-card-base !surface-elevated': !isCollapsed && accordionStyle === 'fill',
        }"
    >
        <div>
            <div
                class="flex cursor-pointer items-center py-4 transition-colors duration-150"
                :class="{
                    'text-neutral-extra-strong': accordionStyle !== 'fill',
                    'text-brand-strong px-4': accordionStyle === 'fill',
                }"
                @click="toggleCollapsed"
            >
                <div class="flex flex-1 items-center space-x-3">
                    <DIcon
                        v-if="icon && icon.name"
                        :icon="icon.name"
                        :icon-set="icon.set"
                        :type="icon.type"
                        class="shape-brand-accent"
                    />
                    <p class="text-lg leading-lg font-ux font-medium text-neutral-base">
                        {{ title }}
                    </p>
                </div>

                <DButton
                    icon="caret-down"
                    icon-set="ph"
                    size="sm"
                    theme="transparent"
                    class="ml-auto transition-transform duration-150 group-hover:surface-mute"
                    :class="{
                        'rotate-180 transform': !isCollapsed,
                    }"
                />
            </div>
        </div>

        <div
            class="ds-accordion-content col-span-2 grid transition-[grid-template-rows] duration-150"
            :class="isCollapsed ? 'grid-rows-[0fr]' : 'z-10 grid-rows-[1fr]'"
        >
            <div class="overflow-hidden">
                <div
                    class="flex items-center space-x-3 pb-4"
                    :class="{
                        'text-neutral-subtle': accordionStyle !== 'fill',
                        'text-brand-strong px-4': accordionStyle === 'fill',
                    }"
                >
                    <!-- used to space the content if theres an icon so content is always inline with title -->
                    <span
                        v-if="icon && icon.name"
                        class="px-3"
                    />
                    <slot />
                    <span
                        v-if="icon && icon.name"
                        class="px-3"
                    />
                </div>
            </div>
        </div>

        <!-- underline -->
        <div v-if="accordionStyle === 'underlines'">
            <div class="border-b border-base" />
        </div>
    </div>
</template>

<script setup>
    import { DIcon, DButton } from '@digistorm/spark'

    const emit = defineEmits(['toggle-active'])

    const props = defineProps({
        id: String,
        title: String,
        icon: Object,
        accordionStyle: String,
        collapsed: {
            type: Boolean,
            default: true,
        },
        activeId: String,
    })

    const isCollapsed = computed(() => {
        return props.activeId !== props.id
    })

    const toggleCollapsed = () => {
        if (props.activeId === props.id) {
            emit('toggle-active', null)
            return
        }
        emit('toggle-active', props.id)
    }
</script>
